import { Checkbox } from 'coreOld/elements';
import { IAccessRank, IRank } from 'system/types';

import { Center } from './userRankAccessStyle';

interface IProps {
  rank: IRank;
  accessRank: IAccessRank;
  onSetUserRankResource;
  checked: boolean;
  isLoading: boolean;
}

const UserRankAccessView = ({
  rank,
  accessRank,
  onSetUserRankResource,
  checked,
  isLoading,
}: IProps) => {
  return (
    <Center>
      <Checkbox
        value={rank.rankId}
        checked={checked}
        onChange={(event) => onSetUserRankResource(event, accessRank)}
        isLoading={isLoading}
      />
    </Center>
  );
};

export default UserRankAccessView;
